export const LOADING_SUCCESS_STATUS="Success"
export const LOADING_FAILURE_STATUS="Failure"
export const PROCESSING="Processing"